import {
    getServerTexts as getTexts,
    initTexts,
    texts as textDictionary
} from '../../../../../Localization/texts';

const entity = 'UI_NEWTECH';

const en = {
    filterBtnLabel: 'Search',
    filterBtnTooltip: 'See your saved searches, or create new with Advanced Search. (Shift+F11)',
    savedSearches: 'Saved Searches',
    createSearch: 'Create New Search',
    setDefault: 'Set as Default',
    unsetDefault: 'Remove Default',
    clearAll: 'Clear All',
    advancedSearch: 'Advanced Search',
    searchHelpTitle: 'Help',
    searchHelpContent:
        'Use the Advanced Search to search for documents and data using a combination of conditions.\n' +
        'Example: Orders you opened last week, in Draft status\n' +
        '\n' +
        'To start, choose the relevant field(s) and fill in the desired conditions.\n' +
        'Example: In the Date field, choose between Start of this Week and Today. In the Status field, choose Draft. In the Assigned to field, choose your user name.\n' +
        '\n' +
        'You can define up to 2 search conditions per field. Use the And operator to include both conditions in your search. Use the Or operator to search using one condition.\n' +
        '\n' +
        'Save the search to reuse the conditions. Choose a name for the search, e.g., My Weekly Orders in Draft.\n' +
        'You can define several saved searches for each form.\n' +
        'Define a default search for the search results to show upon entry to the form, so you don’t start with an empty form.\n' +
        '\n' +
        'See saved searches under the Search button.\n' +
        'You can always update or delete search conditions and create new ones.',
    closeTooltip: 'Close',
    recentSearches: 'Recent Searches',
    editSearchTooltip: 'Edit your search',
    recentSearchName: 'Recent Search #',
    ignoreCase: 'Ignore Case',
    clearSearch: 'Clear Search',
    save: 'Save',
    saveAndSearchPlaceholder: 'Name your search and save it',
    searchSaveBtn: 'Save and search',
    savedSearchSuccessMessage: 'We saved [x].  Keyboard shortcut: Ctrl+X',
    savedSearchSuccessMessageEmptyShortcut:
        'The "[x]" search has been saved in the [index] position.',
    search: 'Search',
    addToResults: 'Add To Results',
    fieldSearchPlaceholder: 'Choose a field...',
    fieldSearchEmptyText:
        'We did not find the field you are looking for. Check the field name and try again.',
    noLabel: 'No',
    yesLabel: 'Yes',
    saveAsDefaultMessage: 'Save [X] as the default search?',
    filterSort: 'Sort results',
    filterSortTooltip: 'Choose to sort by ascending or descending order.',
    deleteSearchWarning: 'Delete this saved search?',
    saveAndSearchLabel: 'Search & save',
    newSearch: 'New Search',
    drawerHelpText: 'You can change the sort order by dragging the search criteria (up or down).',
    okLabel: 'OK',
    searchesTitle: 'Searches',

    newFormLabel: 'New',
    actionsBtnLabel: 'Actions',
    export: 'Export',
    uploadImagePlaceholder: 'Drop image file here to attach, or browse',

    imgCtxSaveAs: 'Save as',
    imgCtxCopyLink: 'Copy document link',
    imgCtxDuplicate: 'Duplicate',

    imgCtxOpen: 'View',
    imgCtxImport: 'Replace',
    imgCtxClear: 'Delete',
    featurePlannedLabel: 'Planned',
    featurePlannedTooltip: 'Will be available in a future update',

    // Field Context Menu labels
    ctxMenuFieldHelpLabel: 'Field Help',
    ctxMenuDesignLabel: 'Design',
    ctxMenuFormDesignLabel: 'Form Design',
    ctxMenuRestoreColWidthLabel: 'Restore Column Widths',
    ctxMenuDefineRecordColorLabel: 'Define Record Color',
    ctxMenuShowCurrRecordColorsLabel: 'Show Current Record Colors',
    ctxMenuNoOfRowsLabel: 'No. of Form Rows',
    ctxMenuSearchByFieldLabel: 'Search by Field',
    ctxMenuMoveAndEditLabel: 'Move/Edit',
    ctxMenuSpecialCopyPasteLabel: 'Special Copy & Paste',
    ctxMenuCopySaveBufferLabel: 'Copy & Save to Buffer',
    ctxMenuPasteFromBufferLabel: 'Paste from Buffer',
    ctxMenuStoreRecordsLabel: 'Store Records',
    ctxMenuRetrieveRecordsLabel: 'Retrieve Records',
    ctxMenuHideRecordLabel: 'Hide record',
    ctxMenuClearAllLabel: 'Clear All',
    ctxMenuDeleteLabel: 'Delete',

    // Screen top menu
    addToFavoritesTooltip: 'Add to Favorites',
    formSettingsTooltip: 'Customize Form Design, Templates & Labels',
    exportToExcelTooltip: 'Export to Spreadsheet',
    searchModeTooltip: 'Switch to Search Mode (F11)',
    changeViewTooltip: 'Change View (F4)',
    printLabelsTooltip:
        'Print labels according to the settings defined in the Prepare Labels program under the Settings menu (gear icon).',
    notificationTooltip: 'Track Document Changes',
    shareTooltip: 'Share',
    deleteRecordTooltip: 'Delete',
    undoChangeTooltip: 'Undo (Ctrl+Z)',
    actionsTooltip: 'In the Actions list, find programs, reports, and forms relevant to this form.',
    formCloseTooltip: 'Exit form (Esc)'
};

const he = {
    filterBtnLabel: 'חיפוש',
    filterBtnTooltip: 'כאן תוכלו לצפות בחיפושים השמורים, או ליצור חיפוש חדש. (Shift+F11)',
    savedSearches: 'חיפושים שמורים',
    createSearch: 'ליצור חיפוש חדש',
    setDefault: 'לקבוע כברירת מחדל',
    unsetDefault: 'ביטול ברירת מחדל',
    clearAll: 'לנקות מסך',
    advancedSearch: 'חיפוש מתקדם',
    searchHelpTitle: 'עזרה',
    searchHelpContent:
        'בעזרת החיפוש המתקדם תוכלו לחפש תעודות ונתונים בהתאם לכמה תנאים במקביל.\n' +
        'לדוגמה: הזמנות, שנפתחו בשבוע האחרון, ונשארו בסטטוס טיוטה.\n' +
        '\n' +
        'כדי להגדיר חיפוש מתקדם נבחר את השדה, או השדות, הרלוונטיים, ונמלא את התנאים הרצויים.\n' +
        'למשל: בשדה "תאריך" נבחר את התנאי “בין” החל מ-תחילת השבוע הנוכחי ועד היום. בשדה "סטטוס" נבחר טיוטה, ובשדה "לטיפול" נבחר את שם המשתמש.\n' +
        '\n' +
        'עבור כל שדה אפשר להגדיר עד שני תנאים לחיפוש. בחרו את האופרטור "וגם" כדי שכל תנאי החיפוש בשדה יתקיימו. בחרו את האופרטור "או" אם מספיק שרק אחד מהתנאים יתקיים.\n' +
        '\n' +
        'אם מדובר בחיפוש שימושי, אפשר לשמור אותו וכך להשתמש באותו חיפוש שוב ושוב, מבלי להגדיר אותו מחדש בכל שימוש. עם שמירת החיפוש נבחר לו שם מתאים, כמו "הזמנות מהשבוע האחרון בטיוטה".\n' +
        'לכל מסך אפשר להגדיר כמה חיפושים שמורים, ולקבוע חיפוש ברירת מחדל.\n' +
        'הגדירו את החיפוש כברירת מחדל אם תרצו שהחיפוש יופעל תמיד בכניסה למסך, כך שלא תצטרכו להתחיל לעבוד במסך ריק.\n' +
        '\n' +
        'כל החיפושים שתשמרו יופיעו תחת כפתור החיפוש.\n' +
        'תמיד אפשר לחזור ולעדכן או למחוק את הגדרות החיפוש, וליצור חיפושים חדשים.',
    closeTooltip: 'לסגור',
    recentSearches: 'חיפושים אחרונים',
    editSearchTooltip: 'עריכת חיפוש',
    recentSearchName: 'חיפוש אחרון #',
    ignoreCase: 'לכלול אותיות רישיות וקטנות',
    clearSearch: 'לנקות חיפוש',
    save: 'שמירה',
    saveAndSearchPlaceholder: 'באיזה שם לשמור את החיפוש שהגדרת?',
    searchSaveBtn: 'שמירה וחיפוש',
    savedSearchSuccessMessage: 'החיפוש [X] נשמר. מקש קיצור: Ctrl+X',
    savedSearchSuccessMessageEmptyShortcut: 'החיפוש [X] נשמר. ',
    search: 'חיפוש',
    addToResults: 'הוסף לתוצאות',
    fieldSearchPlaceholder: 'בחירת שדה',
    fieldSearchEmptyText: 'לא מצאנו את שדה שחיפשתם. בדקו את שם השדה.',
    noLabel: 'לא',
    yesLabel: 'כן',
    saveAsDefaultMessage: 'האם לקבוע את [X] כברירת המחדל?',
    filterSort: 'מיון תוצאות',
    filterSortTooltip: 'בחרו סדר מיון עולה או יורד.',
    deleteSearchWarning: 'למחוק את החיפוש השמור?',
    saveAndSearchLabel: 'שמירה וחיפוש',
    newSearch: 'חיפוש חדש',
    drawerHelpText: 'אפשר לארגן את סדר המיון על ידי גרירה של תנאי החיפוש (למעלה או למטה)',
    okLabel: 'אישור',
    searchesTitle: 'חיפושים',

    newFormLabel: 'חדש',
    actionsBtnLabel: 'פעולות',
    export: 'יְצוּא',
    uploadImagePlaceholder: 'אפשר לגרור לכאן קובץ תמונה או לבחור מתיקייה',

    imgCtxSaveAs: 'שמור בשם',
    imgCtxCopyLink: 'העתק קישור למסמך',
    imgCtxDuplicate: 'שכפל',

    imgCtxOpen: 'פתיחה',
    imgCtxImport: 'החלפה',
    imgCtxClear: 'הסרה',
    featurePlannedLabel: 'בתכנון',
    featurePlannedTooltip: 'אפשרות זו תהיה זמינה בגרסאות הבאות',

    // Field Context Menu labels
    ctxMenuFieldHelpLabel: 'Field Help',
    ctxMenuDesignLabel: 'Design',
    ctxMenuFormDesignLabel: 'Form Design',
    ctxMenuRestoreColWidthLabel: 'Restore Column Widths',
    ctxMenuDefineRecordColorLabel: 'Define Record Color',
    ctxMenuShowCurrRecordColorsLabel: 'Show Current Record Colors',
    ctxMenuNoOfRowsLabel: 'No. of Form Rows',
    ctxMenuSearchByFieldLabel: 'Search by Field',
    ctxMenuMoveAndEditLabel: 'Move/Edit',
    ctxMenuSpecialCopyPasteLabel: 'Special Copy & Paste',
    ctxMenuCopySaveBufferLabel: 'Copy & Save to Buffer',
    ctxMenuPasteFromBufferLabel: 'Paste from Buffer',
    ctxMenuStoreRecordsLabel: 'Store Records',
    ctxMenuRetrieveRecordsLabel: 'Retrieve Records',
    ctxMenuHideRecordLabel: 'Hide record',
    ctxMenuClearAllLabel: 'Clear All',
    ctxMenuDeleteLabel: 'Delete',

    // Screen top menu
    addToFavoritesTooltip: 'הוספה לתפריט אישי',
    formSettingsTooltip: 'הגדרות עיצוב המסך, תבניות ומדבקות',
    exportToExcelTooltip: 'יצוא לגליון נתונים',
    searchModeTooltip: 'מעבר למצב חיפוש (F11)',
    changeViewTooltip: 'שינוי תצוגה (F4)',
    printLabelsTooltip:
        'Print labels according to the settings defined in the Prepare Labels program under the Settings menu (gear icon).',
    notificationTooltip: 'קבלת עדכונים על שינויים בתעודה',
    shareTooltip: 'שיתוף',
    deleteRecordTooltip: 'מחיקה',
    undoChangeTooltip: 'ביטול (Ctrl+Z)',
    actionsTooltip: 'ברשימת הפעולות יש תוכניות, דו”חות, ומסכים הרלוונטיים',
    formCloseTooltip: 'סגירת מסך (Esc)'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'filterBtnLabel',
    2: 'filterBtnTooltip',
    3: 'savedSearches',
    4: 'createSearch',
    5: 'setDefault',
    6: 'clearAll',
    7: '',
    8: 'searchHelpContent',
    9: 'closeTooltip',
    10: 'searchesTitle',
    11: 'recentSearches',
    12: 'editSearchTooltip',
    13: 'recentSearchName',
    14: 'ignoreCase',
    15: 'clearSearch',
    16: 'save',
    17: 'saveAndSearchPlaceholder',
    18: 'searchSaveBtn',
    19: 'savedSearchSuccessMessage',
    20: 'savedSearchSuccessMessageEmptyShortcut',
    21: 'search',
    22: 'addToResults',
    23: 'saveAndSearchLabel',
    24: 'fieldSearchPlaceholder',
    25: 'fieldSearchEmptyText',
    26: 'saveAsDefaultMessage',
    27: 'yesLabel',
    28: 'noLabel',
    29: 'filterSort',
    30: 'filterSortTooltip',
    31: 'deleteSearchWarning',
    32: 'unsetDefault',
    33: 'newSearch',
    34: 'searchHelpTitle',
    35: 'drawerHelpText',
    36: 'okLabel',
    37: 'imgCtxOpen',
    38: 'imgCtxImport',
    39: 'imgCtxClear',
    40: 'featurePlannedLabel',
    41: 'featurePlannedTooltip',
    49: 'deleteRecordTooltip',
    50: 'actionsTooltip',
    51: 'changeViewTooltip',
    52: 'searchModeTooltip',
    53: 'undoChangeTooltip',
    54: 'formCloseTooltip',
    55: 'addToFavoritesTooltip',
    56: 'formSettingsTooltip',
    57: 'exportToExcelTooltip',
    58: 'shareTooltip',
    59: 'notificationTooltip'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

initTexts(entity, fallbacks);

export const texts = textDictionary[entity] as typeof en;
